import { type ExperimentFlags } from './constants';
import { getSearchParam, setSearchParam } from './utils';

/*
 * Функция устанавливает конкретный флаг в GET-параметрах, удаляя параметр, если значение пустое
 *
 * Со стороны пользователя это выглядит, как '/path?flags=flag1=value1;flag2=value2'
 *
 * @example setLocalExperimentalFlag({ name: 'enable_checkout_editor', newValue: 'exp' }) // включить
 * @example setLocalExperimentalFlag({ name: 'enable_checkout_editor', newValue: '' })    // выключить (удалить)
 */
export const setLocalExperimentalFlag = <K extends keyof ExperimentFlags>({
    name,
    newValue,
}: {
    name: K;
    newValue: ExperimentFlags[K] | '';
}) => {
    const flagsString = getSearchParam() || '';
    let flags = flagsString.split(';').filter((flag) => flag.length > 0);
    let flagFound = false;

    flags = flags
        .map((flag) => {
            const [key, value] = flag.split('=');

            if (key === name) {
                flagFound = true;

                // Удаляем флаг, если передано пустое значение
                return newValue ? `${key}=${newValue}` : '';
            }

            return `${key}=${value}`;
        })
        .filter((flag) => flag.length > 0); // Фильтруем пустые строки, образовавшиеся после удаления

    // Если флаг не найден и значение не пустое, добавляем его
    if (!flagFound && newValue) {
        flags.push(`${name}=${newValue}`);
    }

    setSearchParam(flags.join(';'));
};
